export const VERSION = '4.6.0';
// export const BASE_URL = 'https://edunix-api.beetronix.com';
export const BASE_URL = 'https://api.aljenan.edunixsystem.com';
// export const BASE_URL = 'https://api.albayan-schools.com';
